import { Component } from "@angular/core";
import {
	NavController,
	NavParams,
	ViewController,
	App,
	Platform,
	Events
} from "ionic-angular";

import { AddOrderServiceProvider } from "./../../pages/addorder/add-order.service";

import { APIServiceProvider } from "./../../common/services/api.service";
import { HelperServiceProvider } from "./../../common/services/helper.service";

@Component({
	selector: "modal-technicals",
	templateUrl: "./modal-technicals.html"
})
export class TechnicalModalPage {
	list_crops: any = [];
	requestIndex: any = null;
	technical_name:any= null;

	constructor(
		public navCtrl: NavController,
		public viewCtrl: ViewController,
		public platform: Platform,
		public app: App,
		public events: Events,
		public addOrderService: AddOrderServiceProvider,
		public helperService: HelperServiceProvider,
		public apiService: APIServiceProvider,
		public navParams: NavParams
		) {
		this.requestIndex = navParams.get("index");


	}

	dismiss() {
		this.viewCtrl.dismiss();
	}

	ionViewDidLoad() {

		this.technical_name = this.navParams.get("technical_name");
		console.log(this.technical_name);

		this.handelBackButton();
	}

	handelBackButton() {}

	
}




// WEBPACK FOOTER //
// ./src/modals/technicals/technicals.modal.ts